import { ColorsEnum, Text } from '@shared/widgets';
import { UserCorporateOptions } from './userCorporateOptions';
import { UserSecurityOptions } from './userSecurityOptions';

export const UserOptions = () => {
  return (
    <div className='flex-none w-full max-w-80 max-[1200px]:max-w-none'>
      <div className='p-6 bg-white dark:bg-soft-black'>
        <UserCorporateOptions />
        <UserSecurityOptions />
      </div>
      <div className='p-6 bg-white dark:bg-soft-black'>
        <div className='flex flex-col gap-4 text-center'>
          <Text color={ColorsEnum.Secondary}>Your status allows you to edit corporate contacts and the password only.</Text>
          <Text color={ColorsEnum.Gray}>To change your profile info please contact your company administrator.</Text>
        </div>
      </div>
    </div>
  );
};
